var angular = require('angular')

angular.module('AemBranchesAppointments')
  .factory('placesService', placesService)

placesService.$inject = ['$http', 'apiBase']

function placesService ($http, apiBase) {
  var endpointPath = apiBase + 'v3/places'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  return {
    branchDetail: function (id) {
      return $http({
        url: endpoint('branches/' + id),
        method: 'GET',
        cache: true
      })
    }
  }
}
